define('PartLookupSearcher.Item.View', [
	'SCView',
	'partlookupsearcher_item.tpl',
	'underscore',
], function (
	SCViewModule,
	partlookupsearcher_item_tpl,
	_

) {
	'use strict';

	var SCView = SCViewModule.SCView;


	var defaultOptions = {
    template: partlookupsearcher_item_tpl,
  }

	function PartLookupSearcherItemView(options) {
		SCView.call(this, options);

    this.options = _.defaults(options || {}, defaultOptions);
    this.template = this.options.template;
    this.model = this.options.model;
	}

	PartLookupSearcherItemView.prototype = Object.create(SCView.prototype);

	_.extend(PartLookupSearcherItemView.prototype, {
		constructor: PartLookupSearcherItemView,

		template: function () {},

		getContext: function () {
			var searchValue = this.options?.query;
			searchValue = searchValue.trim();
			var field1 = this.model?.get('custitem_sep_parent_model_number')
			var field2 = this.model?.get('custitem_sep_parent_model_number2');

		    var matchingField = null;
			if (!!searchValue && (field1?.includes(searchValue)) || !field2) {
				matchingField = field1; // or return 'field1' if you just want the field name
			}
			if (!!searchValue && (field2?.includes(searchValue)) || !matchingField){
				matchingField = field2; // or return 'field2'
			}
			//console.log('matchingField', matchingField);
			//debugger;
			return {
				model: this.model,
				currentQuery: _(this.options.query).escape(),
				isItemSelected: !!this.model,
				hasResults: this.options.areResults,
				isAjaxDone: this.options.isAjaxDone,
				matchingField: matchingField
			};
		},
	});

	return PartLookupSearcherItemView;
});
